export enum ProductDetailOutlets {
  INTRO = 'PDP.INTRO',
  PRICE = 'PDP.PRICE',
  SHARE = 'PDP.SHARE',
  SUMMARY = 'PDP.SUMMARY',
  REPLACEDBY = 'PDP.REPLACEDBY',
  REPLACEMENTOF = 'PDP.REPLACEMENTOF',
}
